var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGreyAvatar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1_copy_12",
    d: "m17.5,0C27.16,0,35,7.84,35,17.5s-7.84,17.5-17.5,17.5S0,27.16,0,17.5,7.84,0,17.5,0Z",
    fill: "#f5f8fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    d: "m5.02,29.76c.2-.75.53-1.46.96-2.1.72-.97,4.31-2.29,6.19-2.99.32-.12.6-.22.8-.3.12-.04.23-.09.34-.15.4-.43.77-.89,1.12-1.37h.06v-1c-.52-.57-.96-1.21-1.31-1.9-.19-.53-.31-1.09-.35-1.65-1.13-.52-1.27-2.32-1.31-3.33-.02-.49.21-.54.48-.44-.28-.4-.5-.84-.65-1.31-.27-.95-.32-1.95-.17-2.92.03-.6.26-1.17.65-1.63.43-.45,1.13-.48,1.59-.06-.02-.9.49-1.73,1.31-2.12.82-.33,1.7-.5,2.58-.5,1.57-.26,3.17-.03,4.6.66,1.4,1.01,2.19,2.67,2.08,4.39-.05,1.1-.29,2.19-.71,3.21,0,.09-.02.18-.02.28.27-.11.53-.08.5.43-.05,1.01-.18,2.82-1.32,3.33-.07.56-.19,1.11-.36,1.65-.34.69-.78,1.32-1.3,1.89v1.01h.06c.35.48.72.94,1.12,1.37.15.08.49.21,1.12.45,1.87.7,5.48,2.02,6.2,3,.4.58.7,1.22.9,1.89-3.3,3.48-7.89,5.44-12.68,5.43-4.7,0-9.19-1.88-12.48-5.24Z",
    fill: "#808cac"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreyAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grey-avatar.6aa53fa6.svg";
export { ForwardRef as ReactComponent };